const normalizeBaseUrl = (url) => url.replace(/\/$/, "");

export const DOCS_SOURCE = process.env.REACT_APP_DOCS_SOURCE ?? "local";
export const DOCS_CDN_URL = normalizeBaseUrl(process.env.REACT_APP_DOCS_CDN_URL ?? "") + "/product-docs/v1";

export const isDocsLocalMode = () => DOCS_SOURCE !== "s3";
export const isDocsS3Mode = () => DOCS_SOURCE === "s3";
export const isDocsS3Configured = () => isDocsS3Mode() && Boolean(DOCS_CDN_URL);
